var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshBulk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.352 0H4.648C1.736 0 0 1.736 0 4.648v6.696C0 14.264 1.736 16 4.648 16h6.696c2.912 0 4.648-1.736 4.648-4.648V4.648C16 1.736 14.264 0 11.352 0zM8 13.264a4.606 4.606 0 0 1-4.6-4.6c0-2.488 1.984-4.512 4.448-4.6l-.296-.344a.605.605 0 0 1 .056-.848.605.605 0 0 1 .848.056l1.328 1.52c.016.016.024.032.04.048a.6.6 0 0 1 .08.16l.024.096a.53.53 0 0 1-.008.224.938.938 0 0 1-.072.192c-.008.016-.024.032-.032.048a.458.458 0 0 1-.128.12s-.008 0-.008.008L8.128 6.48a.608.608 0 0 1-.84-.128.609.609 0 0 1 .128-.84l.328-.24a3.405 3.405 0 0 0-3.152 3.392c0 1.872 1.528 3.4 3.4 3.4 1.872 0 3.4-1.528 3.4-3.4 0-.672-.2-1.328-.568-1.888a.597.597 0 0 1 .168-.832.596.596 0 0 1 .832.168c.504.76.776 1.64.776 2.552 0 2.536-2.064 4.6-4.6 4.6z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshBulk);
export default __webpack_public_path__ + "static/media/refresh_bulk.fae2cad40d8849615c9f938cbb51d1e4.svg";
export { ForwardRef as ReactComponent };